import App from "@/app";
import i18n from "@/utils/i18n";
import * as Sentry from "@sentry/react";
import dayjs from "dayjs";
import "dayjs/locale/tr";
import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";

import "./index.css";
import "@/assets/scss/typography-utilities.scss";

import {
  matchRoutes,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
} from "react-router-dom";

// Tüm uygulamada dayjs tarih/saat formatlarını Türkçe locale ile üret
// (ör. "DD MMM YYYY" -> "12 Haz 2026", ay/gün adları Türkçe). Aksi halde
// dayjs varsayılan İngilizce locale kullanır ve "June" gibi çıktılar görünür.
dayjs.locale("tr");

// Initialize Sentry for error tracking (configure your DSN in production)
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        createRoutesFromChildren,
        matchRoutes,
        useEffect,
        useLocation,
        useNavigationType,
      }),
      Sentry.replayIntegration(),
    ],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    tracePropagationTargets: [/^\//],
    tracesSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root")!).render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>,
);
